import React from 'react';
import { useLocation } from 'react-router-dom';

import { Card, CardBody, CardHeader, Container, Row } from 'reactstrap';
import SimpleHeader from 'components/Headers/SimpleHeader';
import FormInputs from './FormInputs';

function WebhookForm() {
  const location = useLocation();
  const webHook = location.state?.webhook || {};

  const renderWithBaseLayout = (children) => {
    return (
      <>
        <SimpleHeader showBackArrow="not" />
        <Container className="mt--6" fluid>
          <Row>
            <div className="col">
              <div className="card-wrapper">
                <Card>
                  <CardHeader>
                    <div className="d-flex flex-row justify-content-between">
                      <h3 className="mb-0">
                        {webHook.id ? 'Editar WebHook' : 'Criar WebHook'}
                      </h3>
                    </div>
                  </CardHeader>
                  <CardBody className="pt-2">{children}</CardBody>
                </Card>
              </div>
            </div>
          </Row>
        </Container>
      </>
    );
  };

  const render = () => {
    return renderWithBaseLayout(<FormInputs webHook={webHook} />);
  };

  return render();
}

export default WebhookForm;
